import { render, staticRenderFns } from "./publicHeader.vue?vue&type=template&id=3ac8faf8&scoped=true"
import script from "./publicHeader.vue?vue&type=script&lang=js"
export * from "./publicHeader.vue?vue&type=script&lang=js"
import style0 from "./publicHeader.vue?vue&type=style&index=0&id=3ac8faf8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac8faf8",
  null
  
)

export default component.exports